import React, { useRef, useEffect } from 'react';
import { useDispatch, connect } from 'react-redux';
import { Button } from 'carbon-components-react';
import { Search16 } from '@carbon/icons-react';
import PropTypes from 'prop-types';
import { CFCProps } from 'types';
import { RootState } from 'redux/root.reducer';
import { useComponentMount } from 'utilities/hooks.util';
import { removePin } from 'components/Map/helper';
import { setIsOpenMapLocSearchPanel } from 'redux/map/actions';

const MapLocationSearchButton: React.FC<Props> = ({
  isOpen,
  buttonDisabled,
  buttonClassName
}) => {
  const dispatch = useDispatch();
  const searchButtonRef = useRef<HTMLButtonElement>(null);

  const onClickOpenButton = () => {
    dispatch(setIsOpenMapLocSearchPanel(!isOpen));
  };

  useEffect(() => {
    searchButtonRef?.current?.blur();
  }, [isOpen]);

  useComponentMount(() => {
    return () => {
      removePin();
    };
  });

  return (
    <div className="mls-button-container">
      <Button
        renderIcon={Search16}
        iconDescription="Search"
        tooltipPosition="right"
        hasIconOnly
        kind="tertiary"
        size="field"
        disabled={buttonDisabled === null ? undefined : buttonDisabled}
        className={buttonClassName === null ? undefined : buttonClassName}
        onClick={onClickOpenButton}
        ref={searchButtonRef}
      />
    </div>
  );
};

const propTypes = {
  buttonDisabled: PropTypes.bool,
  buttonClassName: PropTypes.string
};

type ownProps = PropTypes.InferProps<typeof propTypes>;

MapLocationSearchButton.defaultProps = {
  buttonDisabled: false,
  buttonClassName: ''
};

const mapStateToProps = ({ mapCache }: RootState) => ({
  isOpen: mapCache.isOpenMapLocSearchPanel
});

const connector = connect(mapStateToProps);

type Props = CFCProps<typeof connector> & ownProps;

export default connector(MapLocationSearchButton);
